<div class="order-detail desktop">
    <h4 translate> CHECKOUT.ORDER_DETAILS</h4>
    <div class="order-info">
        <span translate>LEARN_MORE_PAGE.BASIC</span>
        <span>{{'KWD' | translate }} 100.000</span>
    </div>
    <hr>
    <div class="order-info total">
        <span translate>CHECKOUT.ORDER_AMOUNT</span>
        <span> {{'KWD' | translate }} 100.000</span>
    </div>
</div>

<div class="order-detail mobile">
    <h4 translate>LEARN_MORE_PAGE.EXAMPLE</h4>
    <div class="product-details">
        <div class="product-logo">
            <img src="assets/images/product-icon.svg" alt="Product logo">
        </div>
        <div class="product-desc">
            <span translate>LEARN_MORE_PAGE.SUN_GLASSES</span>
            <span translate>LEARN_MORE_PAGE.COLOR</span>
        </div>
        <hr>
    </div>
    <div class="prod-total">
        <div class="prod-items">
            <span class="">KD 100.000</span>
            <span>1 item</span>
        </div>
        <div class="total-amaount">
            <span>Total</span>
        </div>
    </div>
</div>